import React from "react";

// Import Css
import './footerComponent.css';

// Import Components
import {SocialMediaComponents} from '../socialMediaComponents/socialMediaComponents.js';


// Import Assets
import LogoIsoFooter from '../../assets/homeAssets/logo-iso-footer.svg'
import iconTelfLocal from '../../assets/homeAssets/iconos-contact/icon-telf-local.svg'
import iconTelfWhatsapp from '../../assets/homeAssets/iconos-contact/icon-telf-whatsapp.svg'
import logoRobotMonitronixFooter from '../../assets/homeAssets/BannerHome/Logo-banner-monitronix.svg'


const styleBkLogoIsoFooter = {
    backgroundImage: `url(${LogoIsoFooter})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    width: '120px',
    height: '100px',
}



export function FooterComponent() {
    return (
        <footer className="component-container">

            <div className="foooter-social-media">
                <SocialMediaComponents />
            </div>

            <div className="footer-container-info">

                <div className="box-logo-sea-footer" style={styleBkLogoIsoFooter}>
                
                        <p className="text-slogan">SEGURIDAD ELECTRÓNICA AVANZADA</p>
                        <p className="text-copyright">Copyright 2026 - 2027</p>

                </div>

                <div className="box-contact-footer">

                    <div className="contact-telf">

                        <h2 className="title-contact-footer">CONTÁCTANOS</h2>
                        <div className="conteiner-box-telf">
                            <div className="box-telf box-telf-1"><a href="tel:022447717" className="telf-movil telf-movil-1">02 2447 717</a><img className="icon-telf-contact icon-telf-contact-1" src={iconTelfLocal} alt="Telf Local"/></div>
                            <div className="box-telf box-telf-2"><a href="tel:0968749960" className="telf-movil telf-movil-2">096 8749 960</a><img className="icon-telf-contact icon-telf-contact-2" src={iconTelfWhatsapp} alt="Telf Whatsapp"/></div>
                            {/* <div className="box-telf box-telf-3"><a href="tel:0991315201" className="telf-movil telf-movil-3">099 1315 201</a><img className="icon-telf-contact icon-telf-contact-3" src={iconTelfWhatsapp} alt="Telf Whatsapp"/></div> */}
                            <div className="box-telf box-telf-4"><a href="mailto:monitronixsas@gmail.com" className="telf-movil telf-movil-4">monitronixsas@gmail.com</a></div>
                        </div>
                    </div>

                    <div className="line-divisor"></div>
                    <div className="box-logo-monitronix-footer"><img className="logo-robot-monitronix-footer" src={logoRobotMonitronixFooter} />  </div>

                </div>

            </div>

        </footer>
    );
}